import {VIRTUALS} from "../../../constants/games";

/*
This function is being used to retrieve the game object out of a specific event instead of
the selected game it self. this function usage prevents the appearance of 404 errors on the
browsers console.
*/
export function getGameFromChannel(channel, games) {
    let game;
    if (games !== undefined && games.length > 0 && channel !== undefined) {
        game = games.find((g) => g.channel === channel);
    }
    return game;
}

export function getGameCategoryIndex(gameIndex) {
    let gameCategories = [...new Set(VIRTUALS.map((game) => game.category.name))]
    let gameCategory = VIRTUALS[gameIndex] ? VIRTUALS[gameIndex].category.name : undefined
    let gameCategoryIndex = gameCategories.findIndex((category) => category === gameCategory)
    return gameCategoryIndex ? gameCategoryIndex : 0
}

export function getGameCategoryNameByChannel(store, channel) {
    let game = store.getState().vpp.games.find((game) => game.channel === channel);
    if (game !== undefined)
        return game.gameCategory;
    return store.getState().vpp.disabledGames.find((game) => game.channel === channel).gameCategory;
}

export function getGameByChannel(store, channel) {
    let game = store.getState().vpp.games.find((game) => game.channel === channel);
    if (game !== undefined)
        return game;
    return store.getState().vpp.disabledGames.find((game) => game.channel === channel);
}


// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/helpers/gameHelpers.js